var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellularDataDisconnectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 6,
    viewBox: "0 0 35 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 34,
    height: 6,
    fill: "#D87E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularDataDisconnectionIcon);
export default __webpack_public_path__ + "static/media/cellular-data-disconnection-icon.93465f030ced060c0bb2a9708c39d523.svg";
export { ForwardRef as ReactComponent };